/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {SurveyFormInputText} from "./SurveyFormInputText";
import {SurveyFormInputDate} from "./SurveyFormInputDate";
import {SurveyFormInputBoolean} from "./SurveyFormInputBoolean";
import {SurveyFormInputFile} from "./SurveyFormInputFile";
import {SurveyFormInputNumber} from "./SurveyFormInputNumber";
import {SurveyFormInputWebMap} from "./SurveyFormInputWebMap";
import {SurveyFormInputTranslator} from "../SurveyFormInputTranslator";
import {RadioInput} from "../../../../../../monitoring/src/Components/Common/Survey/RadioInput";
import SurveyFormInputCheckboxList from "./SurveyFormInputCheckboxList";
import {SurveyFormBooleanWithTextInput} from "./ComposedInputs/SurveyFormBooleanWithTextInput";
import {SurveyFormBooleanWithDateInput} from "./ComposedInputs/SurveyFormBooleanWithDateInput";
import {SurveyFormBooleanWithFileInput} from "./ComposedInputs/SurveyFormBooleanWithFileInput";
import {SurveyFormFileWithTextInput} from "./ComposedInputs/SurveyFormFileWithTextInput";
import {SurveyFormBooleanWithPermitInput} from "./ComposedInputs/SurveyFormBooleanWithPermitInput";
import {SurveyFormInputContactRelationship} from "./SurveyFormInputContactRelationship";
import {SurveyFormBoolPrerequisite} from "./SurveyFormBoolPrerequisite";

export const SurveyFormInputComponentsBySurveyQuestionDataType = {
    "text": SurveyFormInputText,
    "date": SurveyFormInputDate,
    "bool": SurveyFormInputBoolean,
    "file": SurveyFormInputFile,
    "number": SurveyFormInputNumber,
    "webmap": SurveyFormInputWebMap,
    "text_bool": SurveyFormBooleanWithTextInput,
    "date_bool": SurveyFormBooleanWithDateInput,
    "file_bool": SurveyFormBooleanWithFileInput,
    "text_file": SurveyFormFileWithTextInput,
    "permit_bool": SurveyFormBooleanWithPermitInput,
    "label": '', // this survey question type just shows the question and no input fields on the right side.
    "contact_relationship": SurveyFormInputContactRelationship,
    "bool_prerequisite": SurveyFormBoolPrerequisite,
    // TODO: don't dynamically define these?
    "radio": SurveyFormInputTranslator(RadioInput),
    "many-fields": SurveyFormInputTranslator(SurveyFormInputCheckboxList),
};
